import { Paper, Typography } from "@mui/material";
import { ReactNode } from "react";

/**
 * A profile section card (Paper + overline header), shared by the person profile
 * and the parsed-CV candidate card so they look identical.
 */
export const ProfileSection = ({
	title,
	children,
	dataComponent,
}: {
	title: string;
	children: ReactNode;
	dataComponent?: string;
}) => (
	<Paper sx={{ p: 2 }} data-component={dataComponent}>
		<Typography
			variant="overline"
			color="text.secondary"
			sx={{
				fontWeight: "bold",
				letterSpacing: "0.5px",
				mb: 1.5,
				display: "block",
			}}
		>
			{title}
		</Typography>
		{children}
	</Paper>
);
